<template>
	<div class="page">
		<div class="box">
			
			<div class="title">
				<p>隐私政策</p>
			</div>
			
			<div class="tt">
				<p>1、隐私声明 </p>
				<p>虎翼掌上签由深圳虎翼国际旅行社有限公司（以下简称“虎翼掌上签”）开发、运营。虎翼掌上签非常尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，虎翼掌上签会按照本隐私政策的规定使用和披露您的个人信息。但虎翼掌上签将以高度的勤勉、审慎义务对待这些信息。除本隐私政策另有规定外，在未征得您事先许可的情况下，虎翼掌上签不会将这些信息对外披露或向第三方提供。 </p>
				<p>随着虎翼掌上签服务范围的扩大，隐私条款的内容由虎翼掌上签随时更新，且毋须另行通知。更新后的隐私声明一旦公布即有效代替原来的隐私声明。 您在同意虎翼掌上签用户协议之时，即视为您已经同意本隐私政策全部内容。本隐私政策属于虎翼掌上签服务使用协议不可分割的一部分。 </p>
				<p>如果您对我们的隐私政策有任何的疑问或建议，请联系：david@aavisa.com。</p>
			</div>
			
			<div class="tt">
				<p>2、个人信息的收集</p>
				<p>我们会在您自主、自愿使用虎翼掌上签软件提供的各项服务的前提下，收集服务所必需的数据信息，包括： </p>
				<p> (1)、在您注册虎翼掌上签帐号时，您根据虎翼掌上签要求提供的个人注册信息； </p>
				<p> (2)、在您使用虎翼掌上签网络服务，或访问虎翼掌上签网页时，虎翼掌上签自动接收并记录的您的移动端、浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、地理位置信息、软硬件特征信息及您需求的网页记录等数据； </p>
				<p> (3)、在您使用虎翼掌上签时，完成相应服务必须提交的您本人及由您的帐户办理的其他用户的个人资料；</p>
				<p> (4)、虎翼掌上签通过合法途径从商业伙伴处取得的用户个人数据。</p>
				
				<p>如果用户提供的资料不准确，虎翼掌上签保留结束用户使用虎翼掌上签服务的权利。 用户在享用虎翼掌上签服务的同时，同意接受虎翼掌上签提供的各类信息服务。</p>
				<p>您了解并同意，以下信息不适用本隐私权政策：</p>
				<p> (1)、您在使用虎翼掌上签提供的搜索服务时输入的关键字信息；</p>
				<p> (1)、虎翼掌上签收集到的您在虎翼掌上签发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</p>
				<p> (1)、违反法律规定或违反虎翼掌上签规则行为及虎翼掌上签已对您采取的措施。</p>
			</div>
			
			<div class="tt">
				<p>3、个人信息使用与披露</p>
				<p>虎翼掌上签不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和虎翼掌上签（含虎翼掌上签关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。虎翼掌上签亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何虎翼掌上签用户如从事上述活动，一经发现，虎翼掌上签有权立即终止与该用户的服务协议。</p>
				<p>为服务用户的目的，虎翼掌上签可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与虎翼掌上签合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。 </p>
				<p>在如下情况下，虎翼掌上签将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
				<p> (1)、经您事先同意，向第三方披露；</p>
				<p> (2)、为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
				<p> (3)、根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
				<p> (4)、如您出现违反中国有关法律、法规或者虎翼掌上签服务协议或相关规则的情况，需要向第三方披露；</p>
				<p> (5)、如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
				<p> (6)、在虎翼掌上签上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，虎翼掌上签有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</p>
				<p> (7)、其它虎翼掌上签根据法律、法规或者网站政策认为合适的披露。</p>
			</div>
			
			<div class="tt">
				<p>4、个人信息存储和交换</p>
				<p>虎翼掌上签收集的有关您的信息和资料将保存在虎翼掌上签及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或虎翼掌上签收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>
			</div>
			
			<div class="tt">
				<p>5、隐私免责条款</p>
				<p>在如下情况下，虎翼掌上签将不对您的隐私泄露承担责任： </p>
				<p> (1)、您同意公开你的个人资料，享受为您提供的产品和服务；</p>
				<p> (2)、本站需要听从法庭传票、法律命令或遵循法律程序；</p>
				<p> (3)、因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用。</p>
			</div>
			
			<div class="tt">
				<p>6、软件免责声明</p>
				<p>虎翼掌上签同大多数互联网软件一样，受包括但不限于网络服务质量、移动通讯服务或第三方等因素的影响，虎翼掌上签不保证本工具满足您的要求，不保证本工具服务不中断，因上述原因而导致您不能正常使用本工具，虎翼掌上签不承担责任。</p>
			</div>
			
			<div class="tt">
				<p>虎翼掌上签有权在法律规定范围内对本政策进行解释。</p>
			</div>
			
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {

			};
		},
		created() {

		},
		methods: {
			
		}
	}
</script>

<style lang='less' scoped>
	.page{
		text-align: left;
		.box{

		}
		&>div{
			overflow: hidden;
			width: 75rem;
			height: auto;
			margin: 2.5rem auto 7.5rem;
			background-color: #fff;
			
		}
		
		.title{
			color: #333333;
			font-size: 1.875rem;
			text-align: center;
			font-weight: 600;
			border-bottom: 1px solid #eee;
			width: 92%;
			margin:  0 auto;
		}
		
		.tt{
			padding: 0 3.125rem;
			margin-bottom: 1.25rem;
			&>p{
				margin-bottom: 2.5rem;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// src/page/privacy/privacy.vue